import { Component } from 'react';
import {  
        getDateProp,
        getToDoItemDateProps,
        makeBEM,
        datesOnTheSameDay
} from '../global/utils';
import { LABELS, UTILITY_CSS_CLASSES } from '../global/constants';
import Icon from '../atoms/Icon';
import ToDoItemForm from '../forms/ToDoItemForm';
import { FormReveal, RevealAnimation } from './Animations';
import TodoItemController from '../controllers/TodoItemController';
import { GeneralObserver } from './Observer';
import { ConfirmDialog } from './Dialogs';

class ToDoItemModule extends Component {
    constructor(props) {
        super(props);

        this.state = {
            controller: new TodoItemController(this.props.data),
            parentController: this.props.parentController,
            item: this.props.item,
            editMode: false,
            deleteAction: this.props.deleteAction,
            parentEditMode: this.props.parentEditMode,
            animate: this.props.animate,
            showConfirmDialog: false,
        }

        this.observer = false;
        this.moduleName = 'todo-item';
        this.bindFunctions();
    }

    bindFunctions() {
        this.toggleEditMode = this.toggleEditMode.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.reactFn = this.reactFn.bind(this);
        this.promptDeleteConfirm = this.promptDeleteConfirm.bind(this);
        this.discardConfirmDialog = this.discardConfirmDialog.bind(this);
    }

    componentDidMount() {
        this.initialSetup();
    }

    // Setup observer and subscrive to events from controller
    // Fetch data from controller
    initialSetup() {
        const ctrl = this.state.controller;
        const deleteAction = this.state.deleteAction;
        const parentCtrl = this.state.parentController;

        this.observer = new GeneralObserver(this.reactFn);
        ctrl.addObserver(this.observer);

        if ( parentCtrl ) {
            parentCtrl.setupChildObserver(ctrl, this.observer);
        }

        if ( deleteAction ) {
            ctrl.setDeleteAction(deleteAction);
        }

        this.setState({
            controller: ctrl
        });
    }

    // Reacts to controller events
    // Sets controller and item
    reactFn() {
        const ctrl = this.state.controller;
        const item = ctrl.getItem();

        this.setState({
            controller: ctrl,
            item: item,
        })
    }
    
    // Mark done btn handler
    // Calls mark done controller fn
    markDone = () => {
        const ctrl = this.state.controller;
        ctrl.markDone();
    }


    buttonTextHandler = () => {
        var text =  this.state.done ? "x" : "+" ;
        text = "";
        return text;
    }

    // Toggles edit mode
    // Sets editMode state by negating it
    toggleEditMode() {
        this.setState({
            editMode: !this.state.editMode
        })
    }

    // call deleteAction(postData.id)
    // which shoudl call parent (ToDoCtrl) delete fn 
    handleDelete() {
        this.discardConfirmDialog();
        const ctrl = this.state.controller;
        ctrl.deleteSelf();
    }

    // Renders item's start and due dates
    renderDates(toDoItem) {
        const dueDate = toDoItem.dueDate ? toDoItem.dueDate : false;
        const startDate = toDoItem.startDate ? toDoItem.startDate : false;
        let onTheSameDay = false;

        if( startDate && dueDate ) {
            onTheSameDay = datesOnTheSameDay(startDate, dueDate);
            return (
                this.renderDatesTogether(startDate, dueDate)
            );
        } else {
            return this.renderDatesTogether(startDate, dueDate);
        }
    }

    renderDatesTogether(date1, date2) {
        const dateProps = getToDoItemDateProps(date1);

        if ( !date1 && !date2 ) {
            return '';
        }

        if ( datesOnTheSameDay(date1, date2) ) {
            const day =  dateProps.isToday ? LABELS.today : dateProps.day;
            const month = !dateProps.isToday ? getDateProp(date1, "monthNameShort") : '';
            const year = !dateProps.isToday ?
                            `${getDateProp(date1, "yearShort")}` : '';
            const dateModifierClass = dateProps.modifierClass;

            let monthDayAndYear = `${month} ${day}, ${year}`;
            if ( dateProps.isToday ) {
                monthDayAndYear = day;
            }

            return (
                <div className={ makeBEM(this.moduleName, 'dates') }>
                    <div className={ makeBEM(this.moduleName, 'dates-wrapper') }>
                        <span 
                            className={ `date ${dateModifierClass} ${makeBEM(this.moduleName, 'start-date')}` }
                        >
                            { getDateProp(date1, "time") }
                        </span>
                        <span 
                            className={`date ${dateModifierClass} ${makeBEM(this.moduleName, 'due-date')}` }
                        >
                            { getDateProp(date2, "time") } <span className={'month-day-and-year'}>{ monthDayAndYear }</span>
                        </span>
                    </div>
                </div>
            );
        } else {
            const bothDates = (date1 && date2)
            const datesModifierClass = bothDates ? '' : `single-date`;
            return (
                <div className={ makeBEM(this.moduleName, 'dates') }>
                    <div className={ `${makeBEM(this.moduleName, 'dates-wrapper')} ${datesModifierClass}` }>
                        { date1 && this.renderDate(date1) }
                        { date2 && this.renderDate(date2, true) }
                    </div>
                </div>
            );
        }
    }

    renderDate(date1, dueDate=false) {
        const dateProps = getToDoItemDateProps(date1);
        const day =  dateProps.isToday ? LABELS.today : dateProps.day;
        const month = !dateProps.isToday ? getDateProp(date1, "monthNameShort") : '';
        const year = !dateProps.isToday ?
                        `${getDateProp(date1, "yearShort")}` : '';
        const dateModifierClass = dateProps.modifierClass;
        const dateType = dueDate ? 'due-date' : 'start-date';
        let monthDayAndYear = `${month} ${day}, ${year}`;
        if ( dateProps.isToday ) {
            monthDayAndYear = day;
        }
        
        return (
            <span 
                className={ `date ${dateModifierClass} ${makeBEM(this.moduleName, dateType)}` }
            >
                <span className='time'>{ getDateProp(date1, "time") }</span>
                <span 
                    className={'month-day-and-year'}
                >   
                    
                    { monthDayAndYear }
                </span>
            </span>
        )
    }

    promptDeleteConfirm() {
        this.setState({
            showConfirmDialog: true
        });
    }

    discardConfirmDialog() {
        this.setState({
            showConfirmDialog: false
        });
    }


    // Renders item content
    renderContent(toDoItem) {
        if ( !toDoItem ) {
            return false;
        } 
        const done = toDoItem.getDone();
        const toggledClass = done ? UTILITY_CSS_CLASSES.toggled : '';
        const btnClass = `btn--toggle btn--toggle-icon ${toggledClass} ${ makeBEM(this.moduleName, 'done-btn') }`;
        const contentClass = `${makeBEM(this.moduleName, 'content')} ${ UTILITY_CSS_CLASSES.hasAction }`; 

        const showEditBtn = false;
        const editBtnClass = `btn btn--icon btn--small btn--no-border ${makeBEM(this.moduleName, 'edit-btn')}`;

        return (
            <div className={makeBEM(this.moduleName, 'wrapper')}>
                <div className={makeBEM(this.moduleName, 'content-grid')}>
                    <button 
                        className={btnClass}
                        onClick={this.markDone}
                    >
                        {this.buttonTextHandler()}
                        <Icon size="1" name="check"/>
                    </button>
                    <span 
                        className={contentClass} 
                        onDoubleClick={done ? this.promptDeleteConfirm : this.toggleEditMode}
                    >
                        {toDoItem.content }
                    </span>

                    { !done && this.renderDates(toDoItem) }
                </div>

                {
                    showEditBtn &&
                    <button
                        className={ editBtnClass }
                        onClick={this.toggleEditMode}
                    >
                        <Icon name="edit"/>
                    </button>
                }
            </div>
        );
    }
    
    render() {
        const ctrl = this.state.controller;
        const toDoItem = this.state.item;
        const done = toDoItem.done;
        const doneClass = done ? `${this.moduleName}--is-done` : '';
        
        const editMode = !done && this.state.editMode;
        const editModeClass = editMode ? UTILITY_CSS_CLASSES.editing : '';
        const parentEditMode = this.props.parentEditMode;
        const animate = this.state.animate;
        const showConfirmDialog = this.state.showConfirmDialog;

        return (
            <li className={ `${this.moduleName} ${doneClass} ${editModeClass}`}>
                
                {
                    animate ?
                    <RevealAnimation key={toDoItem.id} direction='down'>
                        { this.renderContent(toDoItem) }
                    </RevealAnimation>
                    :
                    this.renderContent(toDoItem)
                }
                {
                    editMode && !parentEditMode &&
                    <FormReveal>
                        <ToDoItemForm 
                            className={makeBEM(this.moduleName, 'edit-form')}
                            toDoItem={toDoItem.toFormObject()} 
                            discardForm={this.toggleEditMode} 
                            deleteSuccess={this.state.deleteAction}
                            controller={ctrl}
                        />
                    </FormReveal>
                }

                {
                    showConfirmDialog &&
                    <ConfirmDialog
                        show={showConfirmDialog}
                        message={LABELS.confirmDelete}
                        confirmAction={this.handleDelete}
                        discardAction={this.discardConfirmDialog}
                    />
                }
            </li>
        );
    }
}

export default ToDoItemModule;